import type { DetailMdScore } from '@/domains/productDiscovery/ArticleReviews/ArticleReviews.model';

export const QUESTION_ID = 1;
export const NB_TOTAL = 10;
export const AVG_RATING = 4.3;

export function getIsTopValueForMoney(data?: DetailMdScore[]) {
  return Boolean(
    data?.some(
      (mdScore: DetailMdScore) =>
        mdScore.questionId === QUESTION_ID &&
        mdScore.nbTotal >= NB_TOTAL &&
        mdScore.avgRating > AVG_RATING,
    ),
  );
}
